/**
 *
 * Custom function
 *
 */

(function ($) {

    /*
     *	Funzione per rendere un box tutto cliccabile. ATTENZIONE: all'interno del box deve esserci un unico link
     */

    function allClick() {
        var clickbox = $('.allclick');
        clickbox.each(function () {
            var $this = $(this);

            $this.css('cursor', 'pointer');
            $this.find('a').click(function (event) {
                event.preventDefault();
            });

            if ($this.find('a').attr('target') == '_blank') {
                $this.click(function () {
                    if($this.hasClass('link-external')){
                        var link = $('a', this).attr('href');

                        $('#externalLinkModal').modal('show');

                        $('.btn-si').off('click').click(function (event) {
                            window.open(link, '_blank');
                            $('#externalLinkModal').modal('hide');
                        });

                        $('.btn-no').off('click').click(function (event) {
                            $('#externalLinkModal').modal('hide');
                        });
                    }
                    else {
                        window.open($('a', this).attr('href'));
                    }
                    
                });
            } else {
                $this.click(function () {
                    window.location.href = $('a', this).attr('href');
                });
            }
        });
    }

    /*
     *	Caricamento ajax delle immagini dal marcatore [data-loadimg] e dei background dal marcatore [data-loadbackground]
     */

    function loadAsynchronousImage() {

        $('*[data-loadimg]').each(function () {
            var box = $(this),
                src = box.attr('data-loadimg'),
                alt = '',
                img = new Image();

            if (box.attr('data-alt')) {
                alt = box.attr('data-alt');
            }

            $(img).load(function () {
                box.append('<img src="' + src + '" alt="' + alt + '" width="' + img.width + '" height="' + img.height + '">');
                $('img', box).hide().fadeIn();

            }).attr('src', src);
        });

        $('*[data-loadbackground]').each(function () {
            var box = $(this),
                src = box.attr('data-loadbackground');

            box.css({
                'background-image': 'url(' + src + ')',
                'background-repeat': 'no-repeat',
                'background-position': 'top center'
            });

            if (box.has(['data-position'])) {
                box.css({
                    'background-position': box.attr('data-position'),
                    'background-image': 'url(' + src + ')',
                    'background-repeat': 'no-repeat'
                });
            } else {
                box.css({
                    'background-position': 'top center',
                    'background-image': 'url(' + src + ')',
                    'background-repeat': 'no-repeat'
                });
            }

            if (box.attr('data-repeat') == 'repeat') {
                box.css({
                    'background-repeat': 'repeat'
                });
            } else {
                box.css({
                    'background-repeat': 'no-repeat'
                });
            }
        });
    }


    /*
     *	Funzione per la gestione dei bottoni "condividi" legati ai social
     */

    function socialOpen() {
        $('[data-socialurl]').each(function () {
            var $this = $(this),
                url = $this.attr('data-socialurl');

            $this.click(function () {
                window.open(url, '', 'width=500, height=500');
            });

        });
    }

    function trackAdwordsCampaign() {
        //$('body').append('<img height="1" width="1" style="border-style:none;" alt="" src=""/>');
    }


    /*
     *	Funzione per l'apertura di una finestra modale tramite cookie
     */

    function openModal() {
        if ($('#onloadmodal').length) {
            if (!$.cookie("openmodal")) {
                $('#onloadmodal').modal();
                $.cookie("openmodal", 'no', {
                    path: '/'
                });
            }
        }
    }



    /*
     *	Funzione per l'apertura di un iframe all'interno di una finestra modale
     */

    function iframeModalOpen() {
        $('.videoModal').each(function () {
            // impostiamo gli attributi da aggiungere all'iframe es: data-src andrà ad impostare l'url dell'iframe
            $('.modalButton').on('click', function (e) {
                var src = $(this).attr('data-src');
                var width = $(this).attr('data-width') || 640; // larghezza dell'iframe se non impostato usa 640
                var height = $(this).attr('data-height') || 360; // altezza dell'iframe se non impostato usa 360

                var allowfullscreen = $(this).attr('data-video-fullscreen'); // impostiamo sul bottone l'attributo allowfullscreen se è un video per permettere di passare alla modalità tutto schermo

                // stampiamo i nostri dati nell'iframe
                $(".videoModal iframe").attr({
                    'src': src,
                    'height': height,
                    'width': width,
                    'allowfullscreen': ''
                });
            });

            // se si chiude la modale resettiamo i dati dell'iframe per impedire ad un video di continuare a riprodursi anche quando la modale è chiusa
            $(this).on('hidden.bs.modal', function () {
                $(this).find('iframe').html("");
                $(this).find('iframe').attr("src", "");
            });
        });
    }

    /*
     *	Funzione per la formattazione delle tabelle con classe listino
     *	tramite le classi di bootstrap
     */

    function responsiveTable() {

        $('.entry-content table').each(function () {
            var $this = $(this);
            $this.addClass('table');
            $this.wrap('<div class="table-responsive"></div>');
        });

        if ($(window).width() <= 767) {

            $('#primary .table-responsive').prepend(
                '<span class="angle-scroll-left">' +
                '<i class="icon icon-edt-arrow-right-6 angle-scroll-left__animation"></i>' +
                '</span>'
            );

            $('#primary .table-responsive').on('scroll', function (event) {
                var angleScrollLeft = $('.angle-scroll-left');

                if ($(this).scrollLeft() >= 1) {
                    angleScrollLeft.addClass('fade-out');
                } else {
                    angleScrollLeft.removeClass('fade-out');
                }
            });

            $('#primary').find('.table-responsive').each(function () {
                var table = $(this);
                $('.angle-scroll-left').click(function (event) {
                    table.animate({
                        scrollLeft: '+=60'
                    }, 200);
                });
            });
        }
    }

    /*
     *	Funzione per l'inizializzazione della mappa
     */
    function initializeGmap() {
        $('#map_canvas').each(function () {
            var map = $(this);
            map.setGMap();
            //var address = map.data;
            // map.setGMap({
            //     address: address
            // });
        });
    }

    /**
     * Funzione per l'attivazione del menu responsive
     */

    function responsiveMenu(viewportSize) {
        $('.main-navigation').find('a[href="#"]').each(function () {
            $(this).click(function (event) {
                event.preventDefault();
            });
        });

        var menuPrimaryOffcanvas = $("#js-menu-primary-offcanvas");

        $('.main-navigation').find('a[href="#"]').each(function () {
            $(this).click(function (event) {
                $('ul.sub-menu').removeClass('open');
                $(this).next().toggleClass('open');
            });
        });

        $("#js-menu-offcanvas-button-open").click(function () {
            menuPrimaryOffcanvas.addClass("offcanvas-open");
        });

        $("#js-menu-offcanvas-button-close").click(function () {
            menuPrimaryOffcanvas.removeClass("offcanvas-open");
        });

        //if ($('body').is('.mobile')) {
        $('a[href="#anchor-specializations"]').click(function () {
            menuPrimaryOffcanvas.removeClass("offcanvas-open");
        });
        //}

        if ($(window).width() <= viewportSize) {
            var fixedMenu = $('#js-fixed-menu')[0];

            if (!fixedMenu) return;

            var stickyHeader = new Waypoint.Sticky({
                element: fixedMenu
            });
        } else {
            var stickyHeader = new Waypoint.Sticky({
                element: $('#js-header')[0],
                // offset: -250 // l'offset è utile se non vuoi far partire subito fisso il menu
            });
        }
    }


    /*
     *  Funzioni per PhotoSwiper
     */
    function addImageSizeForPhotoSwiper() {
        var thumbs = $('img[data-big-size]');
        thumbs.each(function (index) {
            if ($(this).parent('a').length > 0) {
                var isImageLink = $(this).parent('a').attr('href').match(/\.(jpeg|jpg|gif|png)$/);
                if (isImageLink) {
                    big_size = $(this).data('big-size');
                    link = $(this).parent('a');
                    link.attr('data-size', big_size);
                    link.wrap('<div class="single-image"></div>');
                }
            }
        });
    }

    function initPhotoSwiper(selector) {
        var galleryItems = $(selector);
        var pswpItems = [];
        galleryItems.each(function (index) {
            var dimensions = $(this).find('a').data('size').split('x');
            var width = parseInt(dimensions[0], 10);
            var height = parseInt(dimensions[1], 10);

            myImage = {
                src: $(this).find('a').attr('href'),
                w: width,
                h: height,
                msrc: $(this).find('img').attr('src')
            };

            pswpItems.push(myImage);
        });


        galleryItems.each(function (index) {
            $(this).click(function (evt) {
                evt.preventDefault();
                openPhotoSwipe(pswpItems, index);
            });
        });
    }

    function openPhotoSwipe(galleryItems, index) {
        var options = {
            index: index
        };
        var pswpElement = $('.pswp')[0];

        var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, galleryItems, options);
        gallery.init();
    }


    function smoothScroll() {
        $("a[href*='#']").not("[href='#'],[data-toggle]").click(function () {
            if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
                var target = $(this.hash);

                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

                if (target.length) {

                    if (target.attr('data-paddingTopScroll')) {
                        var adjust = target.attr('data-paddingTopScroll');
                    }
                    else {
                        var adjust = target.css('padding-top') ? target.css('padding-top').replace('px', '') : 0;
                    }

                    $('html, body').animate({
                        scrollTop: target.offset().top - adjust
                    }, 1000);

                    return false;
                }
            }
        });
    }

    function startOwl(selector) {
        $(selector).each(function (arguments) {
            var owl = $(this);
            var params = {
                nav: owl.data('owl-navigation'),
                navSpeed: owl.data('owl-slide-speed'),
                autoplay: owl.data('owl-autoplay'),
                autoplayTimeout: owl.data('owl-autoplay-timeout'),
                slideSpeed: owl.data('owl-slide-speed'),
                dots: owl.data('owl-dots'),
                dotsSpeed: owl.data('owl-dots-speed'),
                loop: owl.data('owl-loop'),
                animateOut: owl.data('owl-animate-out'),
                animateIn: owl.data('owl-animate-in'),
                autoHeight: false,
                lazyLoad: true,
                navText: [
                    "<i class='icon-edt-arrow-left-2'></i>",
                    "<i class='icon-edt-arrow-right-2'></i>"
                ]
            };

            if (owl.data('owl-single-item')) {
                params['items'] = 1;
            } else {
                params['responsive'] = {
                    0: {
                        items: owl.data('owl-items-xs'),
                    },
                    768: {
                        items: owl.data('owl-items-sm'),
                    },
                    992: {
                        items: owl.data('owl-items-md'),
                    },
                    1200: {
                        items: owl.data('owl-items-lg'),
                    },
                    1440: {
                        items: owl.data('owl-items-xl'),
                    }
                };
            }

            owl.owlCarousel(params);

            if (owl.data('owl-prev')) {
                $(owl.data('owl-prev')).click(function () {
                    owl.trigger('prev.owl.carousel');
                });
            }
            if (owl.data('owl-next')) {
                $(owl.data('owl-next')).click(function () {
                    owl.trigger('next.owl.carousel');
                });
            }
        });
    }

    function fixForBootstrapModal() {
        // TODO: Add any custom classes with 'position: fixed' to the selector below
        var fixedCls = '.stuck, .info-bar.bottom';
        var oldSSB = $.fn.modal.Constructor.prototype.setScrollbar;
        $.fn.modal.Constructor.prototype.setScrollbar = function () {
            oldSSB.apply(this);
            if (this.bodyIsOverflowing && this.scrollbarWidth) {
                $(fixedCls).css('padding-right', this.scrollbarWidth);
            }
        }

        var oldRSB = $.fn.modal.Constructor.prototype.resetScrollbar;
        $.fn.modal.Constructor.prototype.resetScrollbar = function () {
            oldRSB.apply(this);
            $(fixedCls).css('padding-right', '');
        }
    }

    function disableList() {
        $('.section-specializations .item.box').each(function () {
            if ($(this).hasClass('disabled')) {
                var elem = $(this).closest('.allclick');

                elem.unbind(allClick())
                    .click(false)
                    .css('cursor', 'default')
                    .removeClass('allclick');
            }
        });
    }

    function scrollToMap(elemToScroll) {
        var url = window.location.href,
            urlHash = url.split("#")[1],
            target = $('#' + urlHash);

        if (typeof urlHash !== 'undefined' && urlHash == elemToScroll) {

            $("html,body").animate({ scrollTop: 0 }, 100);

            $('html,body').animate({
                scrollTop: $(target).offset().top - 250
            }, 1000);

            return false;
        }
    }

    function scrollToDoctor() {

        $('a.doc-detail').click(function (event) {
            var url = $(this).attr('href');

            if (typeof (Storage) !== "undefined") {
                sessionStorage.doctorID = $(this).data('doctor-id');
                sessionStorage.doctorSpec = $(this).data('specialization');
                sessionStorage.paddingTop = $(this).data('paddingtopscroll');
            }
        });


        if (sessionStorage.doctorID) {
            var target = $('#' + sessionStorage.doctorID),
                adjust = sessionStorage.paddingTop,
                doctorBox = $(target).closest('.item');

            $(doctorBox).css({
                background: '#f5f5f5',
                padding: '20px',
                WebkitTransition: 'all 0.5s',
                MozTransition: 'all 0.5s',
                MsTransition: 'all 0.5s',
                OTransition: 'all 0.5s',
                transition: 'all 0.5s'
            });

            $("html,body").animate({ scrollTop: 0 }, 100);

            $('html,body').animate({
                scrollTop: $(target).offset().top - adjust
            }, 500);

            sessionStorage.clear();

            return false;
        }
    }

    /*****************************************************************************************/

    function toConsole(string) {
        if ((typeof window.console == "undefined")) {
            alert(string);
        } else console.log(string);
    }

    function $j(argument) {
        var result = jQuery(argument);
        if (result.length === 0) return null;
        else return result;
    }

    function translateCountdown(langCountdown) {

        countdown.resetLabels();

        if (langCountdown == 'it') {
            countdown.setLabels(
                ' millisecondo| secondo| minuto| ora| giorno| settimana| mese| anno| decade| secolo| millennio',
                ' millisecondi| secondi| minuti| ore| giorni| settimane| mesi| anni| decadi| secoli| millenni',
                ' e ',
                ' '
            );
        } else if (langCountdown == 'de') {
            countdown.setLabels(
                ' Millisekunde| zweite| Minute| jetzt| Tag| Woche| Monat| Jahr| Jahrzehnt| Jahrhundert| Jahrtausend',
                ' Millisekunden| Sekunden| Minuten| Stunden| Tage| Wochen| Monate| Alter| Jahrzehnte| Jahrhunderte| Jahrtausende',
                ' und ',
                ' '
            );
        } else if (langCountdown == 'fr') {
            countdown.setLabels(
                ' milliseconde| deuxième| minute| maintenant| jour| semaine| mois| année| décennie| siècle| millénaire',
                ' millisecondes| secondes| minutes| heures| journées| semaines| mois| âge| décennies| siècles| millénaires',
                ' et ',
                ' '
            );
        }

    }

    function edtCountdown() {

        jQuery(".edt_countdown_class").find('.item').each(function () {

            var dataInizio = "";
            var questo = jQuery(this);
            jQuery.post(
                url.ajax_url,
                {
                    'action': 'edita_ajax_get_start_countdown_date',
                    'offerId': questo.data('offerid'),
                },

                function (response) {
                    setInterval(function () {
                        stampaCountdown(questo, response);
                    }, 3600);
                }
            );
        });
    }

    function stampaCountdown(item, response) {

        jQuery(item).find('.pageTimer').empty().append(
            moment().countdown(response, countdown.DAYS | countdown.HOURS).toString()
        );
    }

    function closePhotoswipe() {

        $('.pswp__button--close').click(function () {
            if ($('.pswp').hasClass('pswp--open')) {
                $('.pswp').removeClass('pswp--supports-fs pswp--open pswp--notouch pswp--css_animation pswp--svg pswp--animated-in pswp--visible pswp--zoom-allowed pswp--has_mouse');
            }
        });

        $(window).scroll(function () {
            if ($('.pswp').hasClass('pswp--open')) {
                $('.pswp').removeClass('pswp--supports-fs pswp--open pswp--notouch pswp--css_animation pswp--svg pswp--animated-in pswp--visible pswp--zoom-allowed pswp--has_mouse');
            }
        });
    }

    /*
     * Funzione per utilizzare MixItUp da select
     */

    function filterElements() {

        var filterSelect = '.select-offers',
            container = '.mix-filter-support';

        if($('body').hasClass('page-template-template-riepilogo-news') || $('body').hasClass('page-template-template-archivio-news')) {
            var chosenFilter = 'all';
        }
        else {
            if (sessionStorage.doctorSpec) {
                var chosenFilter = '.' + sessionStorage.doctorSpec;
            }
            else {
                var chosenFilter = '.' + url.firstFilter;
            }
        }
        
        var config = {
            load: {
                filter: chosenFilter,
            },
        };

        if ($(container).length) {
            var mixer = mixitup(container, config);

            if (window.matchMedia("(max-width: 1199px)").matches) {
                $("option[value='" + chosenFilter + "']").attr('selected', 'selected');
            }

            $(filterSelect).on('change', function () {
                mixer.filter(this.value);
            });

            $(container).on('mixStart', function () {

                if (window.matchMedia("(max-width: 1199px)").matches) {
                    var tipologyTitle = $(".select-offers option:selected").text();
                }
                else {
                    var tipologyTitle = $(".mixitup-control-active").text();
                }

                $('.typology-title').text($.trim(tipologyTitle));

            });
        }
    }

    /**
     * Questo oggetto ci serve a verificare il dispositivo utilizzato dall'utente,
     * la i. nell'espressione regolare sta ad indicare una ricerca case-insensitive,
     * il metodo nativo test() serve a verificare la presenza della parola nell'espressione regolare,
     * ritorna un boleano.
     */
    var mapsMobileUrl = {
        isAndroid: function () {
            return /(android)/i.test(navigator.userAgent);
        },
        isIos: function () {
            return /(iPhone|iPad|iPod)/i.test(navigator.userAgent);
        }
    };


    function injectorLinkMaps() {
        var buttonMaps = $('#js-fixed-menu').find('.navigator');

        if (mapsMobileUrl.isAndroid()) buttonMaps.attr('href', phpMapsMobileUrl.android);

        if (mapsMobileUrl.isIos()) buttonMaps.attr('href', phpMapsMobileUrl.ios);

        if (!mapsMobileUrl.isAndroid() && !mapsMobileUrl.isIos()) buttonMaps.hide();
    }

    function pushBarToBottom(elemToPush, header) {
        if (!window.matchMedia("(max-width: 991px)").matches) {
            var topOfElem = $(elemToPush).offset().top;
            var elemHeight = $(elemToPush).outerHeight();
            var headerHeight = $(header).outerHeight();
            var scrolltop = $(window).scrollTop();

            if (!$('div.pushToBottom').length) {
                if ($(window).scrollTop() >= (topOfElem + elemHeight)) {
                    $(elemToPush).wrapAll("<div class='pushToBottom' />");
                    $(elemToPush).addClass('bottom');
                    $(elemToPush + ' .box').height('auto');
                    $(elemToPush + ' .box').equalHeights();
                }
            }
            else {
                if ($(window).scrollTop() <= (headerHeight)) {
                    $(elemToPush).unwrap();
                    $(elemToPush).removeClass('bottom');
                    $(elemToPush + ' .box').height('auto');
                    $(elemToPush + ' .box').equalHeights();
                }
            }

            if ($(window).scrollTop() + $(window).height() > $(document).height() - 100) {
                $('.pushToBottom').addClass('hideBar');
            }
            else {
                $('.pushToBottom').removeClass('hideBar');
            }
        }
    }

    function responsiveEmbedIframe() {
        var elem = $('.entry-content').find('iframe');

        if ($(window).width() <= 1199) {
            $(elem).wrap('<div class="embed-responsive embed-responsive-16by9"></div>');
            $(elem).addClass('embed-responsive-item');
        }
    }

    $j(document).ready(function () {

        allClick();
        responsiveTable();
        addImageSizeForPhotoSwiper();
        iframeModalOpen();
        responsiveMenu(1199);
        filterElements();
        injectorLinkMaps();
        fixForBootstrapModal();
        disableList();
        scrollToDoctor();
        responsiveEmbedIframe();

        $('.reviewBody').collapser({
            mode: 'chars',
            truncate: 290,
            speed: 'fast',
            showText: 'leggi',
            hideText: 'chiudi',
            controlBtn: 'opener',
            afterShow: function () {
                $(this).parent().addClass('show-element');

                // var childElem = $(this).closest('.feedback').children();

                // childElem.each(function( index ) {
                //     if(!$(this).hasClass('show-element')) {
                //         $(this).hide(100);
                //     }
                // });

                $('.review').each(function (index) {
                    if (!$(this).hasClass('show-element')) {
                        $(this).hide(100);
                    }
                });

                $('.feedback-container .owl-theme .owl-nav').hide();
            },
            afterHide: function () {
                // var childElem = $(this).closest('.feedback').children();

                // childElem.each(function( index ) {
                //     if(!$(this).hasClass('show-element')) {
                //         $(this).show(100);
                //     }
                // });

                $('.review').each(function (index) {
                    if (!$(this).hasClass('show-element')) {
                        $(this).show(100);
                    }
                });

                $(this).parent().removeClass('show-element');
                $('.feedback-container .owl-theme .owl-nav').show();

                $(".button-write-feedback").on("click", function () {
                    $('#feedbackModal').modal('show');
                });

                $(".button-route").on("click", function () {
                    if ($(this).find('a').hasClass('enabled')) {
                        $('#routeModal').modal('show');
                    }
                });
            }
            
        });

        $(".link-external").each(function() {
             $(this).on("click", function (e) {    
                e.preventDefault();
                $('#externalLinkModal').modal('show');
                var link = $(this).attr('href');

                $('.btn-si').off('click').click(function (event) {
                    window.open(link, '_blank');
                    $('#externalLinkModal').modal('hide');
                });

                $('.btn-no').off('click').click(function (event) {
                    $('#externalLinkModal').modal('hide');
                });
            });
        });
       

        startOwl('.owl-carousel');
        smoothScroll();

        closePhotoswipe();

        // var mixFilter = $('.mix-filter-support');
        // if ( mixFilter.length ) mixitup(mixFilter);


        if (typeof lang && lang != 'en') {
            translateCountdown(lang);
        }

        edtCountdown();

        $('.gform_wrapper form').each(function () {
            $(this).checkEditaForm();
        });


        $('.checkNewsletter').each(function () {
            $(this).checkEditaForm();
        });

        $('.box.search').click(function () {
            $('.search-bar').slideToggle('fast');
        });

        $('.office-box.box-2').mouseenter(function () {
            $(this).find('.layer').removeClass('closed');
            $('.office-box').not(this).find('.layer').addClass('closed');
        })
            .mouseleave(function () {
                $(this).find('.layer').addClass('closed');
                $('.office-box').not(this).find('.layer').removeClass('closed');
            });

        $('.select-polyclinics').on('change', function () {
            var selected = $(this).find('option:selected').val();
            location = selected;
        });

        if ($(window).width() <= 1199) {
            $(".menu-wrap li a").on("click touchend", function (e) {
                var el = $(this);
                var link = el.attr("href");

                if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
                    var target = $(this.hash);

                    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

                    if (typeof (link) == "undefined") return;

                    if (target.length) {

                        $('html, body').animate({
                            scrollTop: target.offset().top - 100
                        }, 1000);

                        var firstChar = link.charAt(0);

                        if (firstChar == '#') {
                            $("#js-menu-primary-offcanvas").removeClass("offcanvas-open");
                        }

                        window.location = link;
                        e.preventDefault();
                        e.stopPropagation();

                        return false;
                    }
                }

            });
        }

        $('.entry-content iframe[src*="youtube"]').each(function () {
            $(this).wrap('<div class="rwd-video"></div>');
        })

    });


    $j(window).load(function () {

        /*
         *	Attraverso il Google Loader carico il modulo mappa
         */
        $.getScript('https://www.google.com/jsapi', function () {
            // fix per permettere la reimpostazione della mappa ad ogni caricamento di pagina
            sessionStorage.removeItem('edita_geolocation');

            if (url.key) {
                var map_params = 'language=' + url.lingua + '&key=' + url.key;
            }
            else {
                var map_params = 'language=' + url.lingua;
            }
            google.load('maps', '3', {
                other_params: map_params,
                callback: function () {
                    initializeGmap();
                }
            });

        });

        openModal();

        //scrollToMap('map_container');

        var gallery = $('.gallery');

        if (gallery.length) {
            gallery.each(function (index) {
                initPhotoSwiper("#" + $(this).attr('id') + " .gallery-item");
            });
        }

        initPhotoSwiper(".entry-content .single-image");
        initPhotoSwiper(".section-gallery-slideshow .item");

        $('.info-bar .box').equalHeights();
        $('.section-specializations .item.box .title').equalHeights();

        if ($(window).width() >= 768) {
            $('.news-riepilogo .item .item-content').equalHeights();
        }


        if (!window.matchMedia("(max-width: 767px)").matches) {
            $('.section-office-box .office-box').equalHeights();
        }

        if (window.matchMedia("(max-width: 1199px)").matches) {
            var tipologyTitle = $(".select-offers option:selected").text();
        }
        else {
            var tipologyTitle = $(".mixitup-control-active").text();
        }

        $('.typology-title').text($.trim(tipologyTitle));

        function startTimer() {
            var presentTime = $('#timer').text();
            var s = presentTime - 1;

            $('#timer').text(s);
            var timer = setTimeout(startTimer, 1000);

            if (s == 0) {
                clearTimeout(timer);
            }
        }

        if (url.invalidContent) {
            var delay = 5000;
            var first = $(location).attr('pathname');
            var seconds = delay.toString().slice(0, -3);

            first.indexOf(1);
            first.toLowerCase();
            first = first.split("/")[1];

            $('#invalidContentModal').modal({
                backdrop: 'static',
                keyboard: false
            });

            $('#timer').text(seconds);
            startTimer();

            setTimeout(function () { window.location = '/' + first; }, delay);
        }



    });

    $j(window).resize(function () {

        $('.info-bar .box').height('auto');
        $('.section-specializations .item.box .title').height('auto');
        $('.section-office-box .office-box').height('auto');

        $('.info-bar .box').equalHeights();
        $('.section-specializations .item.box .title').equalHeights();
        $('.section-office-box .office-box').equalHeights();

        // if (!$('body').is('.is-mobile')) {
        //     $('.button-info').css({ "position": "static", "width": "100%" });
        //     $('.button-info i').css("right", "15px");
        // }

    });

    $(window).scroll(function () {
        // pushBarToBottom('.info-bar', '.header-slideshow');

        if ($('body').is('.single-specializzazioni')) {

            if ($(window).width() <= 1339) {
                var barHeight = 110;
            }
            else {
                var barHeight = $('.pushToBottom').outerHeight();
            }

            // if ($(window).width() > 1199) {

            //     $(".button-info").pin({
            //         containerSelector: ".specializationContainer",
            //         padding: { top: 500, bottom: 40 },
            //         bottomBarHeight: barHeight,
            //         minWidth: 940
            //     })

            // }

            // if ($(window).width() > 767 && $(window).width() < 992) {
            //     $('.button-info i').css("right", "0");
            // }

        }
    });

})(jQuery);
